import { render, staticRenderFns } from "./BriqMultilanguagePicker.vue?vue&type=template&id=3df958b5&scoped=true&lang=pug&"
import script from "./BriqMultilanguagePicker.vue?vue&type=script&lang=js&"
export * from "./BriqMultilanguagePicker.vue?vue&type=script&lang=js&"
import style0 from "./BriqMultilanguagePicker.vue?vue&type=style&index=0&id=3df958b5&scoped=true&lang=stylus&"
import style1 from "./BriqMultilanguagePicker.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df958b5",
  null
  
)

export default component.exports